<template>
<b-row class="m-2">
    <b-col>
        <b-form id="form-scheduling" @submit="onSubmit">
            <b-row class="OTsectionHeader">
                <b-col c cols="12" md="6">
                    <h1>Scheduling</h1>
                    <p>
                        You can control when your job starts, and how often it will restart. Leave scheduling disabled in order to manually start and stop your job.
                    </p>
                </b-col>
                <b-col class="text-right OTbtnContainer" cols="12" md="6">
                    <b-button type="button" variant=" OTSecondary" @click="$router.push('/jobs')">Cancel</b-button>
                    <b-button type="submit" variant=" OTPrimary" :disabled="$v.$invalid">Save</b-button>
                </b-col>

            </b-row>
            <b-row>
                <b-col class="mt-3">
                    <otif-radio
                       :values="[{value: false, label: 'Disable Scheduling'}, {value: true, label: 'Enable Scheduling'}]"
                       v-model="enable_scheduling"/>
                </b-col>
            </b-row>
            <template v-if="enable_scheduling">
                <b-row>
                    <b-col cols="6" v-if="job.get('job_type') !== 'Twitter Stream'">
                        <otif-select label="Repeat"
                            :values="recurrence_options"
                            v-model="recurrence"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <legend>Starting Date and Time</legend>
                        <DateAndTime v-model="start_date" :validation="$v.start_date" invalidMessage="A starting date and time is required and can not be set in the past"></DateAndTime>
                    </b-col>
                </b-row>
                <b-row v-if="enable_end_date_selection">
                    <b-col>
                        <otif-radio
                                :values="[{value: false, label: 'Run Forever'},{value: true, label: 'Set an End Date'}]"
                            v-model="enable_end_date"/>
                    </b-col>
                </b-row>
                <b-row v-if="enable_end_date">
                    <b-col>
                        <legend>Ending Date and Time</legend>
                        <DateAndTime v-model="end_date" :validation="$v.end_date" invalidMessage="The ending date and time is required and can not be in the past"></DateAndTime>
                    </b-col>
                </b-row>
            </template>
        </b-form>
    </b-col>
</b-row>
</template>

<script>

import { validationMixin } from 'vuelidate';

import { minDate } from '@/validation/dates.js';

import { resourceMapper } from '@/utils/resourceMapper.js';

import DateAndTime from './DateAndTime.vue';
import moment from 'moment';
export default {

    mixins: [ validationMixin ],
    props: ['job'],

    data() {
        return {
            enable_scheduling: false,
            enable_end_date: false,
            schedule_options: ['Enabled', 'Disabled'],
            recurrence_options: [{
                value: 0,
                label: 'Never Repeat'
            },{
                value: 1,
                label: 'Daily'
            },{
                value: 2,
                label: 'Weekly'
            },{
                value: 3,
                label: 'Monthly'
            }],
        }
    },

    computed: {

        enable_end_date_selection() {
            if (this.job.get('job_type') === 'Twitter Stream' || this.recurrence > 0) {
                return true;
            }
        },

        ...resourceMapper([{
            propertyName: 'recurrence',
            attributeName: 'recurrence',
            defaultValue: 0,
            preprocess: parseInt
        },{
            propertyName: 'start_date',
            attributeName: 'start_date'
        },{
            propertyName: 'end_date',
            attributeName: 'end_date'
        }], 'job', 'scheduling')
    },

    validations: {
        start_date: {
            startDate(value) {
                if (this.enable_scheduling === true) {
                    if (!value) {
                        return false;
                    }
                    const now = moment().subtract('minutes', 1);
                    return moment(value).isSameOrAfter(now);
                } else {
                    return true;
                }
            }
        },
        end_date: {
            endDate(value) {
                if (this.enable_scheduling === true && this.enable_end_date === true) {
                    if (!value) { return false }
                    const now = moment().subtract('minutes', 1);
                    return moment(value).isSameOrAfter(now);
                } else {
                    return true;
                }
            }
        }
    },

    components: {
        DateAndTime
    },

    watch: {

        recurrence(newVal) {
            if (newVal === 0) {
                this.enable_end_date = false;
            }
        },

        enable_scheduling(newVal) {
            if (newVal === false) {
                this.$v.$reset();
                this.start_date = null;
                this.end_date = null;
                this.recurrence = 0;
            }
        },

        enable_end_date(newVal) {
            if (newVal === false) {
                this.end_date = null;
            } else if (newVal === true) {
                this.$v.end_date.$touch();
            }
        }
    },

    methods: {
        onSubmit($e) {
            $e.preventDefault();
            this.job.set('next_run', '');
            this.job.save();
        }
    },

    mounted() {
        var breadcrumbs = [{
            name: 'jobs',
            meta: { label: 'Jobs' }
        },{
            name: 'job-edit',
            params: { job_id: this.job.id },
            meta: { label: this.job.get('job_name') }
        },{
            name: 'scheduling',
            params: { job_id: this.job.id },
            meta: { label: 'Scheduling' }
        }];

        this.$store.commit('breadcrumbs', breadcrumbs);
    },


    created() {

        if (this.job.get('start_date')) {
            this.enable_scheduling = true;
            this.$v.start_date.$touch();
        }

        if (this.job.get('end_date')) {
            this.enable_end_date = true;
            this.$v.end_date.$touch();
        }

    }
}

</script>

